import { render } from "./INTPage.vue?vue&type=template&id=1141b326&scoped=true"
import script from "./INTPage.vue?vue&type=script&lang=js"
export * from "./INTPage.vue?vue&type=script&lang=js"

import "./INTPage.vue?vue&type=style&index=0&id=1141b326&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1141b326"]])

export default __exports__